import { handleActions, combineActions } from "redux-actions";
import oauthAppsActions from "./actions";
import update from "immutability-helper";
import cogoToast from "cogo-toast";

const defaultState = {
  list: [],
  count: 0,
  error: "",
};

const oauthAppsReducer = handleActions(
  {
    [oauthAppsActions.GET_OAUTH_APPS_SUCCESS]: (state, action) => {
      const { apps } = action.payload;
      if (apps?.length === 0) cogoToast.error("Nothing found");
      return update(state, { list: { $set: apps || [] }, count: { $set: (apps || []).length } });
    },
    [oauthAppsActions.CREATE_OAUTH_APP_SUCCESS]: (state, action) => {
      // After creating an app, we don't know the full list; simplest is to append nothing and rely on refetch.
      // Caller can trigger GET_OAUTH_APPS again if needed.
      cogoToast.success("OAuth app created");
      return state;
    },
    [oauthAppsActions.DELETE_OAUTH_APP_SUCCESS]: (state) => {
      cogoToast.success("OAuth app deleted");
      return state;
    },
    [combineActions(oauthAppsActions.GET_OAUTH_APPS_ERROR, oauthAppsActions.CREATE_OAUTH_APP_ERROR, oauthAppsActions.DELETE_OAUTH_APP_ERROR)]: (state, action) => {
      const errorMsg =
        action.payload.error?.toString?.() ||
        action.payload.error?.message ||
        action.payload.error?.response?.data?.error?.message ||
        "Failed to load OAuth apps";
      cogoToast.error(errorMsg);
      return update(state, { error: { $set: errorMsg } });
    },
  },
  defaultState
);

export default oauthAppsReducer;
